export { default } from './typography';

//# sourceMappingURL=index.js.map